/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(
  initialState:
    | { currentUser?: API.CurrentUser; roles?: [string]; permissions?: []; schedulingUser: object }
    | undefined,
) {
  const { currentUser, roles, permissions, schedulingUser } = initialState ?? {};
  return {
    //值班人
    canScheduling:
      currentUser && schedulingUser && currentUser.userName === schedulingUser?.userCode,
    normalRolesFilter: (role: string[]) => roles?.some((val) => role.includes(val)), // initialState 中包含了的路由才有权限访问
    canAdmin: roles?.includes('admin'),
    canSls: roles?.includes('sls'),
    canWebLog: roles?.includes('webLog'),
    canLogCenter: roles?.includes('logCenter'),
    canDevelopLog: roles?.includes('developLog'),
    canCS: roles?.includes('clickVisual'),
    canTool: roles?.some((val) => ['sls', 'clickVisual', 'polarDB'].includes(val)),
    canCto: roles?.includes('CTO'),
    canDevops: roles?.includes('devops'),
    canLeader: roles?.includes('team_leader'),
    canGrayReleaseConfig: roles?.includes('gray_release_config'),
    canK8sConfig: roles?.includes('devops'), // k8s集群配置权限
    canViewBusiness:
      roles?.includes('CTO') ||
      roles?.includes('PO') ||
      roles?.includes('PMO') ||
      // initialState?.isBusinessLeader,
      initialState?.isBusinessParticipant,
    canIssueDashboard:
      roles?.includes('CTO') ||
      roles?.includes('PMO') ||
      roles?.includes('PO') ||
      roles?.includes('Product Manager'),
    canAiCoding:
      roles?.includes('CTO') || roles?.includes('frontend') || roles?.includes('backend'),
    canFeedbackAdmin:
      roles?.includes('CTO') || roles?.includes('FBM'),
    canLcAdmin:
      roles?.includes('CTO') || roles?.includes('card_like_manager'),
    // canDelivery: roles?.includes('qa'),
  };
}
